export const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '/api/stp-sales'
export const salesMapUrl = import.meta.env.VITE_API_SALES_MAP_BASE_URL ?? '/api/stp-sales-map'
export const COOKIE_JESSSION_ID = 'JSESSIONID'

// 附件域名
export const ATTACHMENT_DOMAIN = import.meta.env.VITE_APP_ATTACHMENT_DOWNLOAD_URL
